export enum ButtonType {
  Button = 'button',
  Skeleton = 'skeleton',
  Safelist = 'safelist',
}

export enum ButtonTooltip {
  Button = '',
  Skeleton = '',
  Safelist = 'Your channel safelist',
}

export interface Button {
  tooltip: ButtonTooltip;
  type: ButtonType;
}

export const buttons: Record<ButtonType, Button> = {
  [ButtonType.Button]: {
    type: ButtonType.Button,
    tooltip: ButtonTooltip.Button,
  },
  [ButtonType.Skeleton]: {
    type: ButtonType.Skeleton,
    tooltip: ButtonTooltip.Skeleton,
  },
  [ButtonType.Safelist]: {
    type: ButtonType.Safelist,
    tooltip: ButtonTooltip.Safelist,
  },
};
